
export class TechVendorDetails {
    salutationId: string;
    firstName: string;
    lastName: string;
    nickName: string;
    profileUrl: string;
}

export class TechVendorProfile {
    jobTitleId: string;
    lineOfBusinessId: string;
    geographicResponsibilityId: string;
    contactNumbers: any[];
}

export class TechVendorCompleteMyProfile {
    firstName: string;
    lastName: string;
    jobTitleId: string;
    lineOfBusinessId: string;
    geographicResponsibilityId: string;
    contactNumbers: any[];
    geographicalResponsibility: any;
}



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-vendor/shared/models/tech-vendor-profile-model.ts